(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item-custom"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('quick-add-trigger')) return;

    const ADD_BTN = '.js-add-quick-add-variant';
    const mq = window.matchMedia('(max-width: 768px)');

    let current = null;


    /* =========================
       CERRAR CON ESC
    ========================= */

    function onKey(e) {
      if (e.key === 'Escape') {
        close();
      }
    }


    /* =========================
       CLICK EN UNA VARIANTE
    ========================= */

    function onPanelClick(e) {
      if (!current) return;

      if (e.target.closest(ADD_BTN)) {
        setTimeout(() => {
          close();
        }, 250);
      }
    }


    /* =========================
       CERRAR SELECTOR
    ========================= */

    function close() {
      if (!current) return;

      const { panel, btn } = current;

      current = null;

      panel.classList.remove('is-open');

      panel.removeEventListener(
        'click',
        onPanelClick,
        true
      );

      document.removeEventListener(
        'keydown',
        onKey
      );

      btn.setAttribute(
        'aria-expanded',
        'false'
      );
    }


    /* =========================
       ABRIR SELECTOR
    ========================= */

    function open(panel, btn) {

      if (current && current.panel !== panel) {
        close();
      }

      current = {
        panel,
        btn
      };

      panel.classList.add('is-open');

      panel.addEventListener(
        'click',
        onPanelClick,
        true
      );

      document.addEventListener(
        'keydown',
        onKey
      );

      btn.setAttribute(
        'aria-expanded',
        'true'
      );
    }


    /* =========================
       QUICK ADD TRIGGER
    ========================= */

    customElements.define(
      'quick-add-trigger',

      class extends HTMLElement {

        connectedCallback() {

          this.btn = this.querySelector('button');

          if (!this.btn) return;


          /*
            Función que realmente ejecuta
            el quick add.
          */

          this.activate = () => {

            if (!mq.matches) return;

            const media =
              this.closest('.product-item__media');

            if (!media) return;

            const panel =
              media.querySelector('quick-add');

            if (!panel) return;


            const hasVariants =
              this.dataset.hasVariants === 'true';


            const all =
              panel.querySelectorAll(ADD_BTN);

            const available =
              panel.querySelectorAll(
                `${ADD_BTN}:not(.disabled)`
              );


            /* -------------------------
               SIN VARIANTES
               Añadir directamente
            ------------------------- */

            if (!hasVariants) {

              const addButton =
                available[0] || all[0];

              if (addButton) {
                addButton.click();
              }

              return;
            }


            /* -------------------------
               CON VARIANTES
               Abrir / cerrar
            ------------------------- */

            if (
              current &&
              current.panel === panel
            ) {

              close();

            } else {

              open(
                panel,
                this.btn
              );

            }

          };


          /*
            IMPORTANTE:
            Bloqueamos el primer toque para
            que product-media-slider no lo capture
            para mostrar las flechas.
          */

          this.onPointerDown = (e) => {

            if (!mq.matches) return;

            e.stopPropagation();

          };


          /*
            Ejecutamos el quick-add directamente
            al levantar el dedo.

            No esperamos al evento click del navegador.
          */

          this.onPointerUp = (e) => {

            if (!mq.matches) return;

            e.preventDefault();
            e.stopPropagation();

            /*
              Marcamos el click posterior para
              evitar ejecutar dos veces.
            */

            this.ignoreNextClick = true;

            this.activate();

          };


          /*
            CLICK:
            - Evita propagación al slider.
            - Mantiene compatibilidad teclado.
            - Ignora el click generado después
              del pointerup táctil.
          */

          this.onClick = (e) => {

            e.preventDefault();
            e.stopPropagation();

            if (!mq.matches) return;


            if (this.ignoreNextClick) {

              this.ignoreNextClick = false;

              return;

            }


            this.activate();

          };


          /*
            Registramos eventos
          */

          this.btn.addEventListener(
            'pointerdown',
            this.onPointerDown
          );

          this.btn.addEventListener(
            'pointerup',
            this.onPointerUp
          );

          this.btn.addEventListener(
            'click',
            this.onClick
          );

        }


        disconnectedCallback() {

          if (!this.btn) return;


          this.btn.removeEventListener(
            'pointerdown',
            this.onPointerDown
          );

          this.btn.removeEventListener(
            'pointerup',
            this.onPointerUp
          );

          this.btn.removeEventListener(
            'click',
            this.onClick
          );


          if (
            current &&
            current.btn === this.btn
          ) {

            close();

          }

        }

      }
    );


    /* =========================
       CERRAR AL PASAR A DESKTOP
    ========================= */

    mq.addEventListener(
      'change',
      (e) => {

        if (!e.matches) {
          close();
        }

      }
    );

  })();
  } catch(e) { console.error(e); }
})();

})();
